import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage, useIntl } from 'react-intl';
import mail from 'assets/images/Dashboard/mail.png';
import call from 'assets/images/Dashboard/call.png';
import trash from 'assets/images/Dashboard/trash.png';
import rightArrow from 'assets/images/Dashboard/arrow-right.png';
import { superAdminCustomerDetails } from 'routes/AppUrls';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerCallAPI } from 'store/SuperAdmin/getCustomerList/action';
import moment from 'moment';
import Pagination from '@mui/material/Pagination';
import ToastNotification from 'components/common/Toast';
import { deleteCustomerSuperAdminCallAPI } from 'store/SuperAdmin/deleteCustomer/action';
import { useConfirm } from 'material-ui-confirm';
import Lottie from 'lottie-react';
import animationData from 'assets/Lottie/no_data.json';
import ReusableButton from 'components/common/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { getCustomerExportCallAPI } from 'store/SuperAdmin/customerExport/action';
import { ShimmerBox } from 'components/common/Shimmer';

const Customer = () => {
  const navigate = useNavigate();
  const confirm = useConfirm();
  const dispatch = useDispatch();
  const [conf, setConf] = ToastNotification();
  const intl = useIntl();
  const { locale } = useContext(LocaleContext);

  const [page, setPage] = useState(1); // Current page
  const [rowsPerPage, setRowsPerPage] = useState(10); // Items per page

  const customerListData = useSelector(
    (state) => state?.getCustomerReducer?.data
  );

  const customerLoading = useSelector(
    (state) => state?.getCustomerReducer?.loading
  );

  const [totalPages, setTotalPages] = useState(
    Math.ceil((customerListData?.count || 0) / rowsPerPage)
  );
  const [customerList, setCustomerList] = useState(
    customerListData ? customerListData : []
  );

  useEffect(() => {
    getCustomerListApi(rowsPerPage, page);
  }, []);

  const getCustomerListApi = (pageSize, page) => {
    dispatch(
      getCustomerCallAPI(
        { pageSize, page },
        {
          run: true,
          handleFunction: (res) => handleSuccess(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleSuccess = (res) => {
    setCustomerList(res?.data);
    setTotalPages(Math.ceil((res?.data?.count || 0) / rowsPerPage));
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getCustomerListApi(rowsPerPage, value);
  };

  const handleDeleteCustomer = (key) => {
    confirm({
      title: 'Confirm Delete',
      description: 'Are you sure you want to delete Customer ?',
      confirmationText: 'Yes',
      cancellationText: 'No',
      dialogProps: { maxWidth: 'xs' },
      confirmationButtonProps: {
        sx: {
          bgcolor: '#292D32',
          color: '#FFFFFF',
          borderRadius: '0px',
          border: '1px solid #292D32',
          '&:hover': { bgcolor: '#292D32' },
        },
      },
      cancellationButtonProps: {
        sx: {
          bgcolor: 'transparent',
          color: '#292D32',
          borderRadius: '0px',
          border: '1px solid #292D32',
        },
      },
    })
      .then(() => handleConfirmDeleteCustomer(key))
      .catch(() => console.log('Deletion cancelled.'));
  };

  const handleConfirmDeleteCustomer = (key) => {
    dispatch(
      deleteCustomerSuperAdminCallAPI(
        {},
        {
          id: key?.id,
          run: true,
          handleFunction: (res) => handleDeleteSuccess(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleDeleteSuccess = (res) => {
    setConf({
      msg: res?.data?.message,
      variant: 'success',
    });
    getCustomerListApi(rowsPerPage, page);
  };

  ////////////////////////Export//////////////////////////////////////////

  const handleExportExcel = () => {
    dispatch(
      getCustomerExportCallAPI(
        {},
        {
          run: true,
          handleFunction: (res) => handleExportNewWindow(res),
          navigate: navigate,
        }
      )
    );
  };

  const handleExportNewWindow = (res) => {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.data?.data?.length > 0) {
        exportToExcelAndOpenTab(res?.data?.data, 'CustomerList.xls');
      }
    }
  };

  const exportToExcelAndOpenTab = (data, fileName = 'CustomerList.xls') => {
    console.log(data);
    const headers = Object.keys(data[0]);
    const rows = data
      .map(
        (row) =>
          `<tr>${headers
            .map((h) => {
              let value = row[h];
              if (h === 'status') {
                value = value === true ? 'Active' : 'Inactive';
              } else if (h === 'name') {
                value = value?.name_en || null;
              } else if (h === 'last_activity') {
                value =
                  value.map((item) => item.last_activity).join(', ') || null;
              }
              return `<td>${value ?? ''}</td>`;
            })
            .join('')}</tr>`
      )
      .join('');

    const table = `
      <table border="1" style="border-collapse: collapse; width: 100%;">
        <thead>
          <tr style="background-color: #f2f2f2;">
            ${headers.map((h) => `<th style="padding: 8px; text-align: left;">${h?.charAt(0).toUpperCase() + h?.slice(1)}</th>`).join('')}
          </tr>
        </thead>
        <tbody>
          ${rows}
        </tbody>
      </table>
    `;

    const newTab = window.open('', '_blank');
    const html = `
      <html>
        <head>
          <title>${fileName}</title>
          <style>
            body { font-family: sans-serif; padding: 20px; }
            button, a.download-link {
              padding: 8px 12px;
              margin-right: 10px;
              margin-top: 0px;
              background: #007bff;
              color: white;
              text-decoration: none;
              border: none;
              cursor: pointer;
              border-radius: 4px;
            }
          </style>
        </head>
        <body>
          
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <h2>Customer Data</h2>
          <div>
            <a class="download-link" href="#" onclick="downloadExcel()">⬇️ Download</a>
          </div>
        </div>
      
          ${table}
          <script>
            function downloadExcel() {
              const tableHTML = document.querySelector('table').outerHTML;
              const blob = new Blob(["\\ufeff" + tableHTML], {
                type: "application/vnd.ms-excel",
              });
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = "${fileName}";
              a.click();
            }
          </script>
        </body>
      </html>
    `;
    newTab.document.open();
    newTab.document.write(html);
    newTab.document.close();
  };

  ////////////////////////Export//////////////////////////////////////////

  return (
    <Row className="bc-F2F3F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        <div className="flex justify-between items-center">
          <h2 className="fc-292D32 fs-32 fw-400 ff-Akkurat_Bold m-0">
            <FormattedMessage id="Customers" />
          </h2>

          {!customerLoading && (
            <ReusableButton
              fullWidth={false}
              variant="contained"
              color="#F5F5F5"
              fontSize="18px"
              fontWeight="400"
              padding="12px 35px"
              bgColor="#292D32"
              fontFamily="Akkurat"
              endIcon={
                false && (
                  <CircularProgress
                    style={{
                      color: 'white',
                      width: '20px',
                      height: '20px',
                    }}
                  />
                )
              }
              onClick={() => handleExportExcel()}
            >
              <FormattedMessage id="Export to Excel" />
            </ReusableButton>
          )}
        </div>

        <Row className="mt-3 listCustomHeader m-0 p-0 flex items-center">
          <Col lg={1} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
              <FormattedMessage id="Customer & ID" />
            </p>
          </Col>
          <Col lg={1} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
              <FormattedMessage id="User Type" />
            </p>
          </Col>
          <Col lg={1} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
              <FormattedMessage id="Joined On" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
              <FormattedMessage id="Location" />
            </p>
          </Col>
          <Col lg={2} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
              <FormattedMessage id="Contact Info" />
            </p>
          </Col>
          <Col
            lg={1}
            md={6}
            sm={12}
            className="flex items-center justify-center"
          >
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
              <FormattedMessage id="Frequency" />
            </p>
          </Col>
          <Col lg={1} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
              <FormattedMessage id="Last Used" />
            </p>
          </Col>
          <Col lg={1} md={6} sm={12}>
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
              <FormattedMessage id="Last Activity" />
            </p>
          </Col>
          <Col
            lg={2}
            md={6}
            sm={12}
            className="flex items-center justify-center"
          >
            <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat_Bold truncate">
              <FormattedMessage id="Actions" />
            </p>
          </Col>
        </Row>

        <Row className="bc-FFFFFF m-0 p-0">
          {customerLoading ? (
            <>
              {[1, 2, 3, 4, 5].map((item) => (
                <Row
                  key={item}
                  className="m-0 p-0 flex items-center listAppointment"
                >
                  <Col lg={1} md={6} sm={12}>
                    <ShimmerBox width="100px" height="14px" />
                    <ShimmerBox width="80px" height="12px" className="mt-1" />
                  </Col>

                  <Col lg={1} md={6} sm={12}>
                    <ShimmerBox width="80px" height="12px" />
                  </Col>

                  <Col lg={1} md={6} sm={12}>
                    <ShimmerBox width="100px" height="14px" />
                  </Col>

                  <Col lg={2} md={6} sm={12}>
                    <ShimmerBox width="150px" height="12px" />
                  </Col>

                  <Col lg={2} md={6} sm={12}>
                    <ShimmerBox width="150px" height="12px" />
                    <ShimmerBox width="120px" height="12px" className="mt-2" />
                  </Col>

                  <Col
                    lg={1}
                    md={6}
                    sm={12}
                    className="flex items-center justify-center"
                  >
                    <ShimmerBox width="40px" height="12px" />
                  </Col>

                  <Col lg={1} md={6} sm={12}>
                    <ShimmerBox width="100px" height="12px" />
                  </Col>

                  <Col lg={1} md={6} sm={12}>
                    <ShimmerBox width="100px" height="12px" />
                  </Col>

                  <Col
                    lg={2}
                    md={6}
                    sm={12}
                    className="flex items-center justify-center"
                  >
                    <Stack
                      direction="horizontal"
                      gap={3}
                      className="items-center"
                    >
                      <ShimmerBox width="24px" height="24px" />
                      <ShimmerBox width="100px" height="14px" />
                    </Stack>
                  </Col>
                </Row>
              ))}
            </>
          ) : customerList?.results?.length > 0 ? (
            customerList.results.map((key, index) => (
              <Row className="m-0 p-0 flex items-center listAppointment">
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold">
                    {key?.name?.name_en}
                  </p>
                  <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat">
                    {key?.id}
                  </p>
                </Col>

                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1">
                    {key?.role}
                  </p>
                </Col>

                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fw-400 fc-292D32 ff-Akkurat">
                    {key?.joining_on !== null && key?.joining_on !== undefined
                      ? moment(key?.joining_on).format('DD MMM YYYY')
                      : ''}
                  </p>
                </Col>

                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1 truncate">
                    {key?.address}
                  </p>
                </Col>

                <Col lg={2} md={6} sm={12}>
                  <p className="p-0 m-0 fs-12 fw-400 fc-292D32 ff-Akkurat_Bold">
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center "
                    >
                      <img
                        src={mail}
                        alt="icon"
                        style={{ height: '20px', width: '20px' }}
                      />
                      <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat truncate">
                        {key?.email}
                      </p>
                    </Stack>
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center mt-2"
                    >
                      <img
                        src={call}
                        alt="icon"
                        style={{ height: '20px', width: '20px' }}
                      />
                      <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat">
                        {key?.contact_number}
                      </p>
                    </Stack>
                  </p>
                </Col>

                <Col
                  lg={1}
                  md={6}
                  sm={12}
                  className="flex items-center justify-center"
                >
                  <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1">
                    {key?.frequency}
                  </p>
                </Col>

                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1">
                    {key?.last_used
                      ? moment(key?.last_used).format('DD MMM YYYY')
                      : ''}
                  </p>
                </Col>

                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-12 fc-292D32 fw-400 ff-Akkurat mt-1 truncate">
                    {key?.last_activity?.[0]?.last_activity}
                  </p>
                </Col>

                <Col
                  lg={2}
                  md={6}
                  sm={12}
                  className="flex items-center justify-center"
                >
                  <Stack
                    direction="horizontal"
                    gap={3}
                    className="items-center "
                  >
                    <img
                      className="cursor-pointer"
                      src={trash}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                      onClick={() => handleDeleteCustomer(key)}
                    />
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center cursor-pointer"
                      onClick={() =>
                        navigate(superAdminCustomerDetails(locale), {
                          state: { customerId: key?.id },
                        })
                      }
                    >
                      <p className="p-0 m-0 fs-14 fc-292D32 fw-400 ff-Akkurat_Bold underline underline-offset-4">
                        <FormattedMessage id="View Details" />
                      </p>
                      <img
                        src={rightArrow}
                        alt="icon"
                        style={{ height: '20px', width: '20px' }}
                      />
                    </Stack>
                  </Stack>
                </Col>
              </Row>
            ))
          ) : (
            <Row className="bc-FFFFFF m-0 p-50 flex justify-center items-center">
              <Lottie
                animationData={animationData}
                loop={true}
                style={{ height: '200px', width: '200px' }}
              />
            </Row>
          )}
        </Row>

        {customerList?.results?.length > 0 && (
          <Row className="mt-3 m-0 p-0">
            <Stack spacing={2} className="p-0">
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                variant="outlined"
                shape="rounded"
                className="d-flex justify-end"
              />
            </Stack>
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default Customer;
